<template>
  <div class="home">
    <UpperBanner />
    <BookTitleSection />
    <TopSale :products="topsales" />
    <CategorySeven :products="cat7pro" />
    <IslamicCat :products="islamic" />
    <AmilCatVue :products="amiliorer" />
    <EconomyCat :products="economy" />
    <RomansBookVue :products="roman" />
    <div class="reviews-section mb-6">
      <h3 class="text-center mt-8 mb-8 titl">آراء الزبناء</h3>
      <div class="hel" style="width: 90%">
        <div v-for="(review, index) in fakeReviews" :key="index">
          <FakeReview :review="review" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useProductsModule } from "@/stores/products"; // Ensure the correct store name
import { mapState, mapActions } from "pinia";
import UpperBanner from "@/components/home_page/UpperBanner.vue"; // Import your components
import BookTitleSection from "@/components/home_page/liv.vue";
import TopSale from "@/components/home_page/TopSale.vue";
import CategorySeven from "@/components/home_page/CategorySeven.vue";
import IslamicCat from "@/components/home_page/IslamicCat.vue";
import EconomyCat from "@/components/home_page/EconomyCat.vue";
import AmilCatVue from "@/components/home_page/AmilCat.vue";
import RomansBookVue from "@/components/home_page/RomansBook.vue";
import FakeReview from "@/components/home_page/FakeReview.vue";

export default {
  name: "HomeView",
  data() {
    return {
      // Example of fake reviews
      fakeReviews: [
        {
          name: "هاجر الإدريسي",
          date: "2026-05-03",
          rating: 4.5,
          text: "كنتعامل بزاف مع المكتبات الإلكترونية، ولكن Mizabook كانت مختلفة. الجودة عالية بزاف، والتوصيل سريع جداً.",
        },
        {
          name: "أحمد أولحاج",
          avatar: "https://randomuser.me/api/portraits/women/2.jpg",
          date: "2026-01-26",
          rating: 4.0,
          text: "Mizabook قدّمات ليا خدمة أكثر من رائعة. الكتب كانت بجودة عالية والتوصيل كان سريع. أكيد غادي نعاود نطلب مرة أخرى.",
        },
        {
          name: "سارة العمراني",
          date: "2025-10-15",
          rating: 5,
          text: "أول مرة نتعامل مع Mizabook وما غاديش تكون الأخيرة. الكتب جاو في الوقت وبجودة مبهرة، شكراً بزاف!",
        },
      ],
    };
  },
  components: {
    FakeReview,
    UpperBanner,
    BookTitleSection,
    TopSale,
    CategorySeven,
    IslamicCat,
    EconomyCat,
    AmilCatVue,
    RomansBookVue,
  },
  computed: {
    ...mapState(useProductsModule, [
      "topsales",
      "cat7pro",
      "islamic",
      "economy",
      "amiliorer",
      "roman",
      "category",
    ]),
  },

  methods: {
    ...mapActions(useProductsModule, ["getProductstop"]), // Correct store instance
  },
  async mounted() {
    await this.getProductstop();
  },
};
</script>
<style scoped>
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");

.titl {
  font-family: "Noto Kufi Arabic", sans-serif;
}
.reviews-section {
  margin-top: 20px;
}
.hel {
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 935px) {
  .hel {
    display: flex;
    justify-content: center;
  }
}
</style>
